import { PaymentFieldName } from '@/components/PaymentMethod/fields/types';
import { Country } from '@/helpers/conf';
import {
  composeValidators,
  getValidateByLength,
  getIsValidNumber as getValidateByNumber,
  paymentNameRegexValidator,
  required,
  truncateBankNumber,
} from '@/helpers/validators';

export const getCustomWarningValidatorsByFieldName = (
  fieldName: string,
  country: Country
) => {
  const pureFieldName = fieldName
    ?.split('.')
    ?.reverse()?.[0] as PaymentFieldName;

  switch (true) {
    case [
      PaymentFieldName.BANK_CODE,
      PaymentFieldName.CLEARING_NUMBER,
    ].includes(pureFieldName) &&
      [Country.Australia, Country.NewZealand].includes(country):
      return composeValidators(
        required,
        getValidateByNumber(pureFieldName, country, truncateBankNumber),
        getValidateByLength(pureFieldName, 6, 6, country, truncateBankNumber)
      );
    case [
      PaymentFieldName.BANK_ACCOUNT_ID,
      PaymentFieldName.ACCOUNT_NUMBER,
    ].includes(pureFieldName) && country === Country.Australia:
      return composeValidators(
        required,
        getValidateByNumber(pureFieldName, country, truncateBankNumber),
        getValidateByLength(pureFieldName, 6, 10, country, truncateBankNumber)
      );
    case pureFieldName === PaymentFieldName.BENEFICIARY_NAME &&
      country === Country.Australia:
      return composeValidators(
        required,
        getValidateByLength(pureFieldName, 2, 50, country),
        paymentNameRegexValidator(pureFieldName)
      );
    case pureFieldName === PaymentFieldName.BANK_ACCOUNT_LAST_NAME &&
      [Country.Australia, Country.NewZealand].includes(country):
    case pureFieldName === PaymentFieldName.BANK_ACCOUNT_FIRST_NAME &&
      [Country.Australia, Country.NewZealand].includes(country):
      return composeValidators(
        required,
        getValidateByLength(pureFieldName, 2, 25, country),
        paymentNameRegexValidator(pureFieldName)
      );
    case pureFieldName === PaymentFieldName.BANK_ACCOUNT_ID &&
      country === Country.NewZealand:
      return composeValidators(
        required,
        getValidateByNumber(pureFieldName, country, truncateBankNumber),
        getValidateByLength(pureFieldName, 7, 9, country, truncateBankNumber)
      );
    default:
      return composeValidators(required);
  }
};
